import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { capture, EVENTS, setUserProps } from "../analytics/posthog";
import { trackReferralSignup } from "../analytics/firstPromoter";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (new URLSearchParams(location.search).get("new") === "1") {
          setUserProps({ signup_method: "google", workspace_id: data.workspace_id, plan: data.plan });
          capture(EVENTS.signupCompleted, { signup_method: "google" });
          capture(EVENTS.registrationCompleted, { method: "google", signup_method: "google" });
          trackReferralSignup({ email: data.email, uid: data.user_id });
        } else {
          capture(EVENTS.loginCompleted, { method: "google" });
        }
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        if (!data.onboarding_complete) navigate("/onboarding", { replace: true });
        else navigate("/app", { replace: true });
      } catch (e) {
        capture(EVENTS.googleAuthFailed, { status: e?.response?.status || "network" });
        setError("No se pudo completar el acceso con Google.");
        setTimeout(() => navigate("/auth", { replace: true }), 1800);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-obsidian grid-bg">
      <div className="flex flex-col items-center gap-4 text-slate-300">
        <div className="h-6 w-6 rounded-full border-2 border-amber-500 border-t-transparent spin-slow" />
        <span className="mono-label">{error || "ESTABLECIENDO SESIÓN"}</span>
      </div>
    </div>
  );
}
